import ExamScore from './ExamScore';
import ExamScoreHeader from './ExamScoreHeader.view';

export { ExamScore, ExamScoreHeader };

export default ExamScore;
